export const SOCIAL_CHANNEL_ICON_IDS = {
    TWITTER: 'TWITTER',
    FACEBOOK: 'FACEBOOK',
    YOUTUBE: 'YOUTUBE',
    TELEGRAM: 'TELEGRAM',
    INSTAGRAM: 'INSTAGRAM',
};
